import { createFileRoute } from "@tanstack/react-router";
import Footer from "lib/components/footers/LandingPageFooter";
import Navbar from "lib/components/home/Navbar";
import UpdatePasswordForm from "lib/components/home/UpdatePasswordForm";
import getPageTitle from "lib/utils/getPageTitle";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import styles from "../Home.module.scss";

function UpdatePasswordPage() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div style={{ visibility: "hidden" }} />;
  }

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>{getPageTitle("Update Password")}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <Navbar />
      <div className="grid-container full-height">
        <UpdatePasswordForm />
      </div>
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/account/update-password")({
  component: UpdatePasswordPage,
});
